"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
function find(map, keyToFind) {
    var e_1, _a;
    try {
        for (var _b = tslib_1.__values(Array.from(map.entries())), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), key = _d[0], value = _d[1];
            if (lodash_1.default.isEqual(keyToFind, key)) {
                return value;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
var memoizedPartial = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var memoizedPartialFn;
    if (fn._memoizeCache) {
        memoizedPartialFn = find(fn._memoizeCache, args);
    }
    else {
        fn._memoizeCache = new Map();
    }
    if (!memoizedPartialFn) {
        // @ts-ignore
        memoizedPartialFn = lodash_1.default.partial.apply(lodash_1.default, tslib_1.__spread([fn], args));
        fn._memoizeCache.set(args, memoizedPartialFn);
    }
    return memoizedPartialFn;
};
exports.default = memoizedPartial;
//# sourceMappingURL=memoized-partial.js.map